import {FormErrors} from "./form-errors";

export class Editable<T> {
  isModified = false;
  isSubmitting = false;
  isDeleted = false;

  constructor(public record: T, public errors: FormErrors, public isNew = false, public isLoaded = false) {}
}
